import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy, Crown, Medal } from "lucide-react";

export default function Leaderboard() {
  const [top, setTop] = useState([]);
  useEffect(() => { api.get("/leaderboard").then((r) => setTop(r.data.top)); }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="pill">Standings</div>
        <h1 className="font-display text-3xl sm:text-4xl mt-2">Leaderboard</h1>
        <p className="text-sm text-slate-400 mt-2">Ranked by total chips won across all skill tables.</p>
      </div>
      <div className="vexis-card overflow-hidden">
        <div className="grid grid-cols-12 px-5 py-3 border-b border-white/5 text-[11px] font-mono uppercase tracking-widest text-slate-500">
          <div className="col-span-1">#</div>
          <div className="col-span-5">Player</div>
          <div className="col-span-2 text-right">Games</div>
          <div className="col-span-2 text-right">Biggest</div>
          <div className="col-span-2 text-right">Won</div>
        </div>
        <ul className="divide-y divide-white/5">
          {top.map((r, i) => (
            <li key={r.id} className="grid grid-cols-12 px-5 py-3 items-center text-sm" data-testid={`lb-row-${i}`}>
              <div className="col-span-1 font-mono">
                {i === 0 ? <Crown className="w-4 h-4 text-[color:var(--gold)]" /> : i === 1 ? <Medal className="w-4 h-4 text-slate-300" /> : i === 2 ? <Trophy className="w-4 h-4 text-amber-700" /> : <span className="text-slate-500">{i + 1}</span>}
              </div>
              <div className="col-span-5 text-slate-200 truncate">{r.name}</div>
              <div className="col-span-2 text-right font-mono text-slate-400">{r.games_played}</div>
              <div className="col-span-2 text-right font-mono text-slate-300">{r.biggest_win.toLocaleString()}</div>
              <div className="col-span-2 text-right font-mono text-emerald-400">{r.total_won.toLocaleString()}</div>
            </li>
          ))}
          {top.length === 0 && <li className="px-5 py-6 text-slate-500 text-sm">No standings yet.</li>}
        </ul>
      </div>
    </div>
  );
}
